import axios from "axios";
import settings from "./settings";

const API_URL = settings.API_URL;

export const getData = (method, url) => {
    const promise = axios.get(API_URL + url + method)
    const dataPromise = promise.then((response) => {  return response })
    return dataPromise;
}

export const dataWithParameters = (method, url, data) => {
    const promise = axios.post(API_URL + url + method,  data)
    const dataPromise = promise.then((response) => { return response })
    return dataPromise;
}
